// A return URL travels in the query string, so it is untrusted input. Only a same-app path is
// accepted: a single leading slash (not `//host`), no backslashes (plain or percent-encoded,
// which some parsers treat as a slash) or control characters, and never the login page itself,
// which would loop.
export function sanitizeReturnUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return null;
  }

  if (/[\\\u0000-\u001f\u007f]|%5c/i.test(value)) {
    return null;
  }

  if (/^\/login(?:[/?#;]|$)/.test(value)) {
    return null;
  }

  return value;
}
